module.exports = __webpack_public_path__ + "img/to-your-head-mobile_380x402.0f771a9a.jpg";